module.exports = __webpack_public_path__ + "img/Running-for-Joy.dc29b8be.jpg";